import type {Fee} from "./types";

import {type OptionType} from "@/client/components/Select";

export const entityTypes: OptionType<Fee["entityType"]>[] = [
    {
        value: "MANDATORY",
        label: "Mandatory"
    },
    {
        value: "MANDATORY_PAL",
        label: "Mandatory Pal"
    },
    {
        value: "OPTIONAL",
        label: "Optional"
    }
];

export const feeTypes: OptionType<Fee["feeType"]>[] = [
    {
        value: "DEPOSIT",
        label: "Deposit"
    },
    {
        value: "GENERAL",
        label: "General"
    },
    {
        value: "PET_FEE",
        label: "Pet fee"
    }
];

export const taxTypes: OptionType<NonNullable<Fee["taxType"]>>[] = [
    {
        value: "TAXABLE",
        label: "Taxable"
    },
    {
        value: "NOT_TAXABLE",
        label: "Not taxable"
    }
];

export const valueTypes: OptionType<NonNullable<Fee["valueType"]>>[] = [
    {
        value: "FLAT",
        label: "Amount"
    },
    {
        value: "PERCENT",
        label: "Percent"
    }
];

export const units: OptionType<Fee["unit"]>[] = [
    {
        value: "PER_DAY",
        label: "Per day"
    },
    {
        value: "PER_PERSON",
        label: "Per person"
    },
    {
        value: "PER_STAY",
        label: "Per stay"
    },
    {
        value: "PER_DAY_PER_PERSON",
        label: "Per day per person"
    },
    {
        value: "PER_DAY_PER_PERSON_EXTRA",
        label: "Per day per person extra"
    }
];
